export function initLanguageSwitchHreflang() {
    const links = (typeof GLOBALS !== 'undefined') ? GLOBALS.hreflangLinks : {};
    if (!links || !Object.keys(links).length) return;

    document.querySelectorAll('.languageSwitchList a').forEach(anchor => {
        const href = anchor.getAttribute('href') || '';
        const match = href.match(/^\/([a-z]{2,})\//);
        if (match && links[match[1]]) {
            anchor.setAttribute('href', links[match[1]]);
        }
    });
}
